import { ISelectOption, scheduling } from "lobbie";
import { ReactNode, useCallback, useMemo, useState } from "react";
import { Dropdown, DropdownButton, Form } from "react-bootstrap";
import PatientSchedulingUserDetailsChildForm from "./PatientSchedulingUserDetailsChildForm";
import { usePatientSelfSchedulingContext } from "src/hooks/patient_scheduling/usePatientSelfSchedulingContext";

interface IProps {
    label: ReactNode;
    child: scheduling.patient.IPatientDetailsChild;
    index: number;
    selectedChildIndex: number | undefined;
    options: ISelectOption[];
    handleSelect: (index: number) => void;
    handleSavingNewChild: (child: scheduling.patient.IPatientDetailsChild, index: number) => void;
}

const PatientSchedulingUserDetailsChildCard: React.FC<IProps> = ({
    label,
    child,
    index,
    selectedChildIndex,
    options,
    handleSelect,
    handleSavingNewChild,
}) => {
    const { selfScheduleSettings } = usePatientSelfSchedulingContext();

    const [isEditingChild, setEditingChild] = useState<boolean>(false);
    const handleSetEditingChild = useCallback(() => setEditingChild(true), []);
    const handleSetNotEditingChild = useCallback(() => setEditingChild(false), []);

    const handleSaveEdit = useCallback(
        (editedChild: scheduling.patient.IPatientDetailsChild) => {
            handleSavingNewChild(editedChild, index);
            setEditingChild(false);
        },
        [index, handleSavingNewChild],
    );

    const handleSelectIndex = useCallback(() => handleSelect(index), [handleSelect, index]);
    const isSelected = useMemo(() => selectedChildIndex === index, [selectedChildIndex, index]);

    return (
        <>
            <div className="border rounded form-control d-flex flex-row ml-0">
                <Form.Check
                    inline
                    className="bold col-11"
                    type="radio"
                    id={`children-option-${index}`}
                    label={
                        <span className="w-100 pointer" onClick={handleSelectIndex}>
                            {label}
                        </span>
                    }
                    onChange={handleSelectIndex}
                    checked={isSelected}
                />
                <div className="align-items-center justify-content-center d-flex ml-auto flex-col">
                    <DropdownButton
                        id="patient-scheduling-user-card"
                        variant="bg-transparent border-transparent shadow-none pr-0 extra-bold"
                        title={"⋮"}
                    >
                        <Dropdown.Item as="button" onClick={handleSetEditingChild} className="py-3">
                            <span className="link underline">
                                Edit{" "}
                                {selfScheduleSettings?.patientFieldName?.toLowerCase() || "patient"}
                            </span>
                        </Dropdown.Item>
                    </DropdownButton>
                </div>
            </div>
            {isEditingChild && (
                <PatientSchedulingUserDetailsChildForm
                    options={options}
                    handleSavingNewChild={handleSaveEdit}
                    handleCancel={handleSetNotEditingChild}
                    existingChild={child}
                />
            )}
        </>
    );
};
export default PatientSchedulingUserDetailsChildCard;
